import * as React from "react";
import Dropzone from "react-dropzone";

import { FileUploadRequest } from "src/requests/CommonRequest";

import * as fileUtil from "../../common/Methods/FileUtil";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

interface Props {
    attachments: Array<FileUploadRequest>;
    disabled?: boolean;
    updateAttachmentLog: (attachments: FileUploadRequest[]) => void;
    multiple?: boolean;
}

export default class AttachmentsForm extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        const attachmentLog = this.props.attachments || [];
        const multiple = this.props.multiple;

        return (
            <>
                {(multiple || attachmentLog.length === 0) && (
                    <Dropzone
                        onDrop={async acceptedFiles => {
                            const updateAttachmentLog = attachmentLog.slice();
                            for (let i = 0; i < acceptedFiles.length; i++) {
                                try {
                                    const file = acceptedFiles[i];
                                    const data = await fileUtil.FileToBase64(file);
                                    updateAttachmentLog.push({
                                        name: file.name,
                                        contentType: file.type,
                                        data
                                    });
                                } catch (e) {
                                    console.error(e);
                                }
                            }
                            this.props.updateAttachmentLog(updateAttachmentLog);
                        }}
                        multiple={multiple}
                        disabled={this.props.disabled}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <section>
                                <div {...getRootProps()} className={`rounded attachmentLog py-2 `}>
                                    <input {...getInputProps()} />
                                    <p
                                        className={`text-center text-secondary my-0`}
                                        style={{
                                            opacity: this.props.disabled ? 0.5 : 1
                                        }}
                                    >
                                        Drag &amp; drop here or click to upload a file
                                    </p>
                                </div>
                            </section>
                        )}
                    </Dropzone>
                )}

                {this.props.attachments.length > 0 && (
                    <ul className="list-group">
                        {this.props.attachments.map((attachment, index) => (
                            <li className="list-group-item py-0 px-0" key={index}>
                                <button
                                    className="btn btn-secondary btn-sm btn-block d-flex px-3 py-2"
                                    onClick={e => {
                                        e.preventDefault();
                                        const attachments = this.props.attachments.filter(
                                            attachmentState => attachmentState.name !== attachment.name
                                        );
                                        this.props.updateAttachmentLog(attachments);
                                    }}
                                >
                                    {attachment.name}
                                    <FontAwesomeIcon icon={faTimes} className="mt-1 ml-auto" style={{ opacity: 0.6 }} />
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/AttachmentsForm.tsx